<template>
  <v-container fluid>
      <v-card>
        <v-toolbar dense flat >
          <v-btn v-show="mode === 'page'" @click="back()" icon light>
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <v-toolbar-title>{{title}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
          <v-card-text>
            <v-layout row>
              <v-layout justify-end row wrap>
              <v-chip
                v-for="tag in tags"
                :key = tag.id
                small
                disabled
                text-color="secondary"
                @click="editNotesDialogOpen()"
                >
                <span class="text-xs-center">
                {{tag.name}}
                </span>
              </v-chip>
              </v-layout>
              </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="editNotesDialogOpen()">Изменить</v-btn>
          </v-card-actions>
      </v-card>
      <v-flex xs12 md12 pa-2>
        <v-card flat ref="scroll_target">
          <v-toolbar dense flat >
            <v-toolbar-title>Документы
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-ops-btn :cxt="cxtDoc"></v-ops-btn>
          </v-toolbar>
          <v-container pt-2 px-2
            fluid
            grid-list-lg
            style="min-height: 0; margin-top: "
          >
            <v-layout row wrap >

              <template v-for="item in documents">
                <v-flex xs12 sm6>
                <v-card>
                  <v-card-title>
                    <span class="subheading"><component :is="createDocTitle(item)"></component></span>
                    <v-spacer></v-spacer>
                  </v-card-title>
                  <v-card-text>
                    <component :is="createDocContent(item)">
                    </component>  
                  </v-card-text>
                  <v-card-actions>
                    <v-btn @click="openDoc(item)">Изменить</v-btn>
                  </v-card-actions>
                </v-card>
                </v-flex>
              </template>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex xs12 md12 pa-2>
        <v-card flat ref="scroll_target">
          <v-toolbar dense flat >
            <v-toolbar-title>Контакты
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="openContact(null)">
              <v-icon>add</v-icon>
            </v-btn>            
          </v-toolbar>
          <v-container pt-2 px-2
            fluid
            grid-list-lg
            style="min-height: 0; margin-top: "
          >
            <v-layout row wrap >

              <template v-for="item in contacts">
                <v-flex xs12 sm6>
                <v-card>
                  <v-card-title>
                    <span class="subheading"><component :is="createContactTitle(item)"></component></span>
                    <v-spacer></v-spacer>
                  </v-card-title>
                  <v-card-text>
                    <component :is="createContactContent(item)">
                    </component>  
                  </v-card-text>
                  <v-card-actions>
                    <v-btn @click="openContact(item)">Изменить</v-btn>
                  </v-card-actions>
                </v-card>
                </v-flex>
              </template>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  // import server from '../../api/server'
  import formats from '../../api/formats'
  import classes from '../../api/classes'
  import dialogs from '../common/dialogs'
  import vOpsBtn from '../common/OpsBtn'
  import vPanelTitle from '../info/PanelTitle'
  import vNotesForm from '../info/NotesForm'
  import people from '../people/index.js'

  export default {
    name: 'c-agent-page',
    components: {vPanelTitle, vOpsBtn},
    data: () => ({
      title: '',
      strategy: null,
      cxtDoc: null,
      notesEditable: true,
      ref: null,
      clientCompanyId: null,
      banks: [],
      favoriteLists: null,
      privateNotes: null,
      notes: null,
      tags: null,
      accountNameShort: null,
      otherAttribs: []
    }),
    props: {
      // itemId: {
      //   type: String,
      //   default: null
      // },
      fullscreen: {
        type: Boolean,
        default: false
      },
      mode: {
        type: String,
        default: 'page'
      }
    },
    created () {
      this.strategy = people.createStrategy(this, 'INDIVIDUAL')
      let cxt = new classes.MultiSelectContext(() => {})
      cxt.actionIcon = 'add'
      // cxt.mode = classes.modes.SELECT
      cxt.actions.push(new classes.Action(this, 'Паспорт РФ', null,
        () => this.openDoc(null, 'PASSPORT_RF')))
      cxt.actions.push(new classes.Action(this, 'Свидетельство о рождении РФ', null,
        () => this.openDoc(null, 'BIRTH_CERT_RF')))
      cxt.actions.push(new classes.Action(this, 'Временное удоостоверение личности РФ',
        null,
        () => this.openDoc(null, 'TEMPORARY_ID_RF')))
      cxt.actions.push(new classes.Action(this, 'Свидет о пенс. страховании РФ',
        null,
        () => this.openDoc(null, 'PENSION_CERT_RF')))
      cxt.actions.push(new classes.Action(this, 'Водительское удостоверение',
        null,
        () => this.openDoc(null, 'DRIVER_LIC_RF')))
      cxt.actions.push(new classes.Action(this, 'Свидетельство о заключении брака',
        null,
        () => this.openDoc(null, 'MARRIAGE_CERT_RF')))
      this.cxtDoc = cxt
    },
    mounted () {
      if (this.itemId) {
        this.fetchFavoriteProps(this.itemId)
      }
    },
    watch: {
      itemId: function (newVal, oldVal) { // watch it
        if (newVal) {
          this.fetchFavoriteProps(newVal)
        } else {

        }
      }
    },
    computed: {
      ...mapGetters({
        getProfileHaveClient: 'getProfileHaveClient'
      }),
      itemId () {
        return this.$route.params.cagentId
      },
      genders () {
        return people.genders()
      },
      citizenships () {
        return people.citizenships()
      },
      contacts () {
        let items = this.profile ? this.profile.contacts : []
        return people.sortIndividualContact(items)
      },
      documents () {
        let items = this.profile ? this.profile.docs : []
        return people.sortIndividualDoc(items)
      }
    },
    methods: {
      back () {
        this.$router.go(-1)
      },
      fetchFavoriteProps (refCode) {
        this.$store.dispatch('getFavoriteRefs', refCode).then((data) => {
          if (!Array.isArray(data) || data.length < 1) {
            console.log('fetchFavoriteProps', data)
            return
          }
          if (this.getProfileHaveClient) {
            this.ref = data[0].ref
            this.title = this.ref ? this.ref.caption : ''
            this.clientCompanyId = data[0].clientCompanyId
            this.banks = data[0].banks
            this.favoriteLists = data[0].tags
            this.privateNotes = data[0].privateNotes
            this.notes = data[0].notes
            this.tags = data[0].tags
            this.monitoring = data[0].monitoring
            this.accountNameShort = data[0].accountNameShort
            this.otherAttribs = data.slice(1)
          } else {
            this.ref = null
            this.clientCompanyId = null
            this.banks = []
            this.favoriteLists = null
            this.privateNotes = null
            this.notes = null
            this.tags = null
            this.monitoring = false
            this.accountNameShort = null
            this.otherAttribs = []
          }
        })
      },
      fetchIndividual (id) {
        if (id) {
          return this.strategy.fetchData(id).then(data => {
            this.profile = data
            this.title = this.strategy.viewTitle(this.strategy.createModelFromData(this.profile))
          })
        } else {
          this.back()
        }
      },
      editProfile () {
      },
      createProfileContent () {
        if (this.strategy && this.strategy.viewContentComp) {
          return this.strategy.viewContentComp(this.strategy.createModelFromData(this.profile))
        }
        return this.createComp('<span></span>')
      },
      openContact (item) {
        // console.log('openContact', this.fullscreen)
        people.openContact(item ? item.id : null, this.itemId).then(() => {
          this.fetchIndividual(this.itemId)
        })
      },
      createContactTitle (item) {
        let strategy = people.createStrategy(this, 'CONTACT')
        if (strategy && strategy.viewTitleComp) {
          return strategy.viewTitleComp(strategy.createModelFromData(item))
        }
        return this.createComp('<span>Новый тип документа</span>')
      },
      createContactContent (item) {
        let strategy = people.createStrategy(this, 'CONTACT')
        if (strategy && strategy.viewContentComp) {
          return strategy.viewContentComp(strategy.createModelFromData(item))
        }
        return this.createComp('<span></span>')
      },
      openDoc (item, type) {
        people.openDoc(item ? item.id : null, this.itemId, item ? item.type : type).then(() => {
          this.fetchIndividual(this.itemId)
        })
      },
      createDocTitle (item) {
        let strategy = people.createStrategy(this, item.type)
        if (strategy && strategy.viewTitleComp) {
          return strategy.viewTitleComp(strategy.createModelFromJSON(item.model))
        }
        return this.createComp('<span>Новый тип документа</span>')
      },
      createDocContent (item) {
        let strategy = people.createStrategy(this, item.type)
        if (strategy && strategy.viewContentComp) {
          return strategy.viewContentComp(strategy.createModelFromJSON(item.model))
        }
        return this.createComp('<span></span>')
      },
      createComp (template) {
        return formats.createComp(template)
      },
      editNotesDialogOpen: function (item) {
        if (!this.notesEditable) {
          return
        }
        var self = this
        const setNotes = function (data) {
          self.refreshCompanyProps()
        }
        dialogs.register('v-notes-form', vNotesForm)
        var comp = { template: `
          <v-notes-form v-on:input="setNotes" v-on:close="$emit('close')" :fullscreen="fullscreen" :model="model"></v-notes-form>
        `,
          data () {
            return {
              model: {clientCompanyId: self.clientCompanyId, banks: self.banks, company: {reference: self.ref, name: {caption: self.ref.caption}}, privateNotes: self.privateNotes, notes: self.notes, tags: self.tags, monitoring: self.monitoring},
              setNotes: setNotes,
              fullscreen: self.$vuetify.breakpoint.xsOnly
            }
          }
        }
        dialogs.modal(comp)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// CAgentPage.vue?0312a6b8